import { Outlet } from 'react-router-dom';

import { SiteFooter } from './components/SiteFooter';
import { SiteHeader } from './components/SiteHeader';

/**
 * Chrome for the public marketing pages: floating header plus the full footer.
 *
 * Which chrome a page gets is decided here, by the layout route it sits under,
 * rather than by pathname checks inside the header and footer themselves.
 */
export const MarketingLayout = () => (
  <>
    <SiteHeader variant="marketing" />
    <main className="flex-1 text-left">
      <Outlet />
    </main>
    <SiteFooter />
  </>
);
